import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
    static emailValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const emailRegex = /^[a-zA-Z0-9!$%&'*+-/=^_`.{|}~@]+@[a-zA-Z0-9!$%&'*+-/=^_`.{|}~@]+\.[a-zA-Z]{2,}$/;

            const isValid = emailRegex.test(control.value);

            return isValid ? null : { invalidEmail: true };
        };
    }

    static nameValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const regex = /^[A-Za-z'\s-]+$/;

            const isValid = regex.test(control.value);

            return isValid ? null : { invalidName: true };
        };
    }

    static emptyInputValidator(inputValue: FormControl): ValidationErrors | null {
        if (!inputValue.value) {
            return null;
        }
        return inputValue!.value.trim() !== '' ? null : { emptyInput: true };
    }

    static emptyStringOrObjectValidator(inputValue: FormControl<string | { value: string }>): ValidationErrors | null {
        if (typeof inputValue.value === 'string') {
            return inputValue!.value?.trim() !== '' ? null : { emptyInput: true };
        } else {
            return inputValue!.value?.value?.trim() !== '' ? null : { emptyInput: true };
        }
    }
}
